import PrivacyPolicy from "./pages/PrivacyPolicy/PrivacyPolicy";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Start, { UserState } from "./pages/Start/Start";
import DeleteDataPage from "./pages/DeleteDataPage/DeleteDataPage";
import { useEffect, useState } from "react";
import { User, onAuthStateChanged } from "firebase/auth";
import { auth } from "./config/firebaseConfig";
import { Sign } from "crypto";
import SignIn from "./pages/auth/SignIn";
import LoginPage from "./pages/LoginPage/LoginPage";
import { Box, CircularProgress } from "@mui/material";

const App = () => {
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState<User | null>(null);
  const [userState, setUserState] = useState<UserState>(UserState.SIGN_IN);

  useEffect(() => {
    setLoading(true);
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      setLoading(false);
    });

    return () => unsubscribe(); // Clean up the listener on unmount
  }, []);

  return (
    <BrowserRouter>
      {loading ? (
        <Box
          sx={{
            position: "absolute",
            left: "50%",
            top: "50%",
          }}
        >
          <CircularProgress size={100} />
        </Box>
      ) : (
        <>
          <Routes>
            <Route path="/">
              {user ? (
                <Route index element={<Start />} />
              ) : (
                <Route index element={<LoginPage />} />
              )}
              <Route path="privacy" element={<PrivacyPolicy />} />
              <Route path="delete" element={<DeleteDataPage />} />
            </Route>
          </Routes>
        </>
      )}
    </BrowserRouter>
  );
};

export default App;
